<mat-form-field [appearance]="appearance" class="w-100">
  <mat-label>{{ placeholder }}@if (htmlOnlyRequired) {
    <span class="html-required">{{ 'filters.required-marker' | translate }}</span>
  }</mat-label>
  <mat-select
    #selectElem
    [placeholder]="placeholder"
    [formControl]="formControl"
    [multiple]="multiple"
    [(value)]="selectedValue"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onOpenedChange($event)"
    panelWidth=""
    >
    <div class="box-search">
      @if (multiple && selectAll) {
        <mat-checkbox
          color="primary"
          class="box-select-all"
          [(ngModel)]="selectAllChecked"
          (change)="toggleSelectAll($event)"
        ></mat-checkbox>
      }
      <mat-icon class="search-icon">search</mat-icon>
      <input
        [(ngModel)]="searchInput"
        name="searchInput"
        type="text"
        class="box-search-input"
        [ngClass]="{ 'box-search-input-no-select-all pl-1': !selectAll }"
        [placeholder]="selectPlaceholder | translate"
        (keydown)="$event.stopPropagation()"
        (input)="$event.stopPropagation()"
        (keyup)="triggerSearch()"
        #textInput
        />
      <div class="box-clear-icon" (click)="clearSearch()">
        <button mat-icon-button class="clear-button">
          <mat-icon class="mat-24" aria-label="Clear icon">clear</mat-icon>
        </button>
      </div>
    </div>
    <mat-select-trigger>
      {{ onDisplayString() }}
    </mat-select-trigger>
    @if (!options || options.length <= 0 || filteredOptions?.length <= 0) {
      <mat-option
        [disabled]="true"
        class="no-checkbox"
        >-- No Items Found --</mat-option
        >
      }
      @for (option of options; track option[value]) {
        <mat-option
          [disabled]="option.disabled"
          [value]="option[value]"
          [class.hidden-option]="hideOption(option)"
          >{{ option[display] }}
        </mat-option>
      }
    </mat-select>
    @if (showErrorMsg) {
      <mat-hint style="color: red">{{ errorMsg }}</mat-hint>
    }
  </mat-form-field>
